import React from 'react';
import { BookOpenIcon, CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProductSection() {
  return <section className="w-full py-20 px-6 pt-[30px] pb-[30px]" style={{
    background: 'var(--cream-dark)'
  }} aria-label="El producto" data-id="element-363">
      <div className="max-w-5xl mx-auto" data-id="element-364">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-365">
          <p className="text-sm font-bold tracking-widest uppercase mb-4" style={{
          color: 'var(--gold-dark)'
        }} data-id="element-366">
            🍰 Te Presento
          </p>
          <h2 className="text-5xl md:text-6xl font-bold mb-4" style={{
          color: 'var(--brown)',
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-367">
            Dulce Libertad
          </h2>
          <p className="text-xl italic mb-6" style={{
          color: 'var(--gold-dark)',
          fontFamily: 'Cormorant Garamond, serif',
          fontSize: '1.3rem'
        }} data-id="element-368">
            Método Repostería Zero
          </p>
          <p className="text-lg max-w-2xl mx-auto leading-relaxed" style={{
          color: '#1a0f0a'
        }} data-id="element-369">
            No es un libro de recetas. Es un sistema completo de repostería que
            transforma para siempre la manera en que horneas para ti y para las
            personas que amas.
          </p>
        </div>

        {/* System chapters */}
        <div className="mb-16" data-id="element-370">
          <h3 className="text-2xl font-bold mb-8 text-center" style={{
          color: 'var(--brown)'
        }} data-id="element-371">
            🔬 Antes de las Recetas: El Sistema Completo
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-372">
            <div className="rounded-2xl p-8" style={{
            background: 'var(--cream)',
            border: '1px solid var(--blush)'
          }} data-id="element-373">
              <div className="text-3xl mb-4" data-id="element-374">📖</div>
              <h4 className="font-bold text-lg mb-2" style={{
              color: 'var(--brown)',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-375">
                Cap. 1 — El Mito del Cartón
              </h4>
              <p className="text-sm leading-relaxed mb-4" style={{
              color: '#1a0f0a'
            }} data-id="element-376">
                Por qué fallan los postres sin gluten y la ciencia detrás del
                Método Repostería Zero
              </p>
              <p className="text-sm font-bold" style={{
              color: 'var(--sage)'
            }} data-id="element-377">
                ✓ Entiendes el por qué antes del cómo
              </p>
            </div>
            <div className="rounded-2xl p-8" style={{
            background: 'var(--cream)',
            border: '1px solid var(--sage-light)'
          }} data-id="element-378">
              <div className="text-3xl mb-4" data-id="element-379">🛒</div>
              <h4 className="font-bold text-lg mb-2" style={{
              color: 'var(--brown)',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-380">
                Cap. 2 — La Despensa Master LATAM
              </h4>
              <p className="text-sm leading-relaxed mb-4" style={{
              color: '#1a0f0a'
            }} data-id="element-381">
                Las 3 Mezclas Maestras + Sistema de 3 Endulzantes + Guía
                completa de sustitutos de lácteos
              </p>
              <p className="text-sm font-bold" style={{
              color: 'var(--sage)'
            }} data-id="element-382">
                ✓ Tu cocina lista para hornear cualquier receta
              </p>
            </div>
            <div className="rounded-2xl p-8" style={{
            background: 'var(--cream)',
            border: '1px solid var(--gold-light)'
          }} data-id="element-383">
              <div className="text-3xl mb-4" data-id="element-384">🔑</div>
              <h4 className="font-bold text-lg mb-2" style={{
              color: 'var(--brown)',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-385">
                Cap. 3 — Los 5 Secretos de la Textura
              </h4>
              <p className="text-sm leading-relaxed mb-4" style={{
              color: '#1a0f0a'
            }} data-id="element-386">
                Hidratación, reposo, temperatura, orden de mezcla y horneado
                inteligente + Tabla de Solución de Problemas
              </p>
              <p className="text-sm font-bold" style={{
              color: 'var(--sage)'
            }} data-id="element-387">
                ✓ Nunca más un postre seco o que se desmorona
              </p>
            </div>
          </div>
        </div>

        {/* Recipe categories */}
        <div className="mb-16" data-id="element-388">
          <h3 className="text-2xl font-bold mb-8 text-center" style={{
          color: 'var(--brown)'
        }} data-id="element-389">
            🍽️ Las 52 Recetas Completas
          </h3>
          <div className="flex flex-col gap-6" data-id="element-390">
            {/* Tortas */}
            <div className="rounded-2xl overflow-hidden" style={{
            background: 'var(--cream)'
          }} data-id="element-391">
              <div className="px-8 py-5 flex items-center gap-4" style={{
              background: 'var(--brown)'
            }} data-id="element-392">
                <span className="text-2xl" data-id="element-393">🎂</span>
                <div data-id="element-394">
                  <h4 className="font-bold text-lg" style={{
                  color: 'var(--gold-light)',
                  fontFamily: 'Playfair Display, serif'
                }} data-id="element-395">
                    12 Tortas y Pasteles Húmedos
                  </h4>
                </div>
              </div>
              <div className="px-8 py-6" data-id="element-396">
                <p className="leading-relaxed mb-3" style={{
                color: '#1a0f0a'
              }} data-id="element-397">
                  Desde el Bizcocho de Vainilla perfecto para empezar hasta el
                  Pastel de Tres Leches Vegano y la Torta Selva Negra Libre para
                  impresionar en cualquier celebración. Incluyendo el Brownie
                  Fudge que nadie cree que es saludable y el Red Velvet con
                  color rojo 100% natural de remolacha.
                </p>
                <p className="text-sm italic" style={{
                color: 'var(--gold-dark)'
              }} data-id="element-398">
                  Dificultad desde ⭐ hasta ⭐⭐⭐ — hay recetas para todos los
                  niveles.
                </p>
              </div>
            </div>

            {/* Galletas */}
            <div className="rounded-2xl overflow-hidden" style={{
            background: 'var(--cream)'
          }} data-id="element-399">
              <div className="px-8 py-5 flex items-center gap-4" style={{
              background: '#5C3D2E'
            }} data-id="element-400">
                <span className="text-2xl" data-id="element-401">🍪</span>
                <div data-id="element-402">
                  <h4 className="font-bold text-lg" style={{
                  color: 'var(--gold-light)',
                  fontFamily: 'Playfair Display, serif'
                }} data-id="element-403">
                    10 Galletas y Snacks Crujientes
                  </h4>
                </div>
              </div>
              <div className="px-8 py-6" data-id="element-404">
                <p className="leading-relaxed mb-3" style={{
                color: '#1a0f0a'
              }} data-id="element-405">
                  Las Galletas de Chispas de Chocolate que crujen de verdad. Los
                  Alfajores Sin Gluten con dulce de leche de coco. Las Barras
                  Energéticas listas en 20 minutos sin horno. La Granola
                  Crujiente que convierte cualquier desayuno en un placer.
                </p>
                <p className="text-sm italic" style={{
                color: 'var(--gold-dark)'
              }} data-id="element-406">
                  La técnica del crujido perfecto que ningún otro libro sin
                  gluten te enseña.
                </p>
              </div>
            </div>

            {/* Postres de cuchara */}
            <div className="rounded-2xl overflow-hidden" style={{
            background: 'var(--cream)'
          }} data-id="element-407">
              <div className="px-8 py-5 flex items-center gap-4" style={{
              background: 'var(--brown)'
            }} data-id="element-408">
                <span className="text-2xl" data-id="element-409">🍮</span>
                <div data-id="element-410">
                  <h4 className="font-bold text-lg" style={{
                  color: 'var(--gold-light)',
                  fontFamily: 'Playfair Display, serif'
                }} data-id="element-411">
                    10 Postres de Cuchara
                  </h4>
                </div>
              </div>
              <div className="px-8 py-6" data-id="element-412">
                <p className="leading-relaxed mb-3" style={{
                color: '#1a0f0a'
              }} data-id="element-413">
                  El Mousse de Chocolate Oscuro más aireado que hayas probado.
                  El Flan de Vainilla con caramelo perfecto sin azúcar. El
                  Tiramisú Sin Gluten y Sin Lácteos que vale cada uno de sus
                  minutos de preparación. La Crema Catalana con esa costra
                  crujiente que todos esperan romper.
                </p>
                <p className="text-sm italic" style={{
                color: 'var(--gold-dark)'
              }} data-id="element-414">
                  Postres para impresionar en cualquier mesa.
                </p>
              </div>
            </div>

            {/* Helados */}
            <div className="rounded-2xl overflow-hidden" style={{
            background: 'var(--cream)'
          }} data-id="element-415">
              <div className="px-8 py-5 flex items-center gap-4" style={{
              background: '#5C3D2E'
            }} data-id="element-416">
                <span className="text-2xl" data-id="element-417">🍦</span>
                <div data-id="element-418">
                  <h4 className="font-bold text-lg" style={{
                  color: 'var(--gold-light)',
                  fontFamily: 'Playfair Display, serif'
                }} data-id="element-419">
                    8 Helados y Paletas
                  </h4>
                </div>
              </div>
              <div className="px-8 py-6" data-id="element-420">
                <p className="leading-relaxed mb-3" style={{
                color: '#1a0f0a'
              }} data-id="element-421">
                  Cremosos de verdad. Sin máquina heladera. Desde el Helado de
                  Vainilla Clásico hasta el Helado de Dulce de Leche de Coco.
                  Paletas en capas de colores naturales que los niños piden una
                  y otra vez.
                </p>
                <p className="text-sm italic" style={{
                color: 'var(--gold-dark)'
              }} data-id="element-422">
                  El secreto anticongelante que hace que tus helados sean suaves
                  y nunca un bloque de hielo.
                </p>
              </div>
            </div>

            {/* Especiales */}
            <div className="rounded-2xl overflow-hidden" style={{
            background: 'var(--cream)'
          }} data-id="element-423">
              <div className="px-8 py-5 flex items-center gap-4" style={{
              background: 'var(--brown)'
            }} data-id="element-424">
                <span className="text-2xl" data-id="element-425">🎉</span>
                <div data-id="element-426">
                  <h4 className="font-bold text-lg" style={{
                  color: 'var(--gold-light)',
                  fontFamily: 'Playfair Display, serif'
                }} data-id="element-427">
                    10 Postres Especiales para Fechas Especiales
                  </h4>
                </div>
              </div>
              <div className="px-8 py-6" data-id="element-428">
                <p className="leading-relaxed mb-3" style={{
                color: '#1a0f0a'
              }} data-id="element-429">
                  La Rosca de Reyes Sin Gluten para el 6 de enero. El Pan de
                  Muerto para las ofrendas mexicanas. La Marquesa de Chocolate
                  venezolana. El Pionono Navideño del Cono Sur. La Torta
                  Arcoíris que sorprende a todos cuando la cortas. Los Huevos de
                  Pascua de Chocolate para regalar.
                </p>
                <p className="text-sm italic" style={{
                color: 'var(--gold-dark)'
              }} data-id="element-430">
                  Ninguna tradición latinoamericana queda fuera de este libro.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Extras table */}

        <div className="flex justify-center" data-id="element-431">
          <CTAButton text="QUIERO MIS RECETAS" subtext="Acceso inmediato • PDF en cualquier dispositivo" data-id="element-432" />
        </div>
      </div>
    </section>;
}